"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var Panel = _antd.Collapse.Panel;
var text = "  A dog is a type of domesticated animal.  Known for its loyalty and faithfulness,  it can be found as a welcome guest in many households across the world.";
var Demo = function Demo() {
  return /*#__PURE__*/_react.default.createElement(_antd.Collapse, {
    defaultActiveKey: ['1']
  }, /*#__PURE__*/_react.default.createElement(Panel, {
    header: "This is panel header 1",
    key: "1"
  }, /*#__PURE__*/_react.default.createElement("p", null, text)), /*#__PURE__*/_react.default.createElement(Panel, {
    header: "This is panel header 2",
    key: "2"
  }, /*#__PURE__*/_react.default.createElement("p", null, text)), /*#__PURE__*/_react.default.createElement(Panel, {
    header: "This is panel header 3",
    key: "3"
  }, /*#__PURE__*/_react.default.createElement("p", null, text)));
};
var componentDemo = {
  demo: /*#__PURE__*/_react.default.createElement(Demo, null),
  tokens: ['colorTextSecondary', 'colorText', 'colorFillAlter', 'colorBgContainer'],
  key: 'default'
};
var _default = exports.default = componentDemo;